'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  name: 'loaded',
  play: function play() {
    // this is called via the tuner after a successful load
    var context = {
      shouldLogStatus: true
    };
    _tuner2.default.changeState(_tuner2.default.states.connecting, context);
  }
};

exports.default = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=loaded.js.map